/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { productsCreate } from "../../funcs/productsCreate.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: components.CreateProductRequestEntity$inboundSchema,
};

export const tool$productsCreate: ToolDefinition<typeof args> = {
  name: "products-create",
  description: `Creates a new product.

Create a new product for one-time payments or subscriptions. Configure pricing, billing cycles, and features.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await productsCreate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
